<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script setup lang="ts">
import { onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { setUnauthorizedHandler } from '@/services/api'

const router = useRouter()
const auth = useAuthStore()

// Sesión expirada a mitad de uso: un 401 en cualquier request de datos limpia
// la sesión local y lleva al login con aviso, en vez de dejar la app fallando
// en silencio (tablas vacías, botones que "no hacen nada").
setUnauthorizedHandler(() => {
  // Sin usuario en memoria no hay sesión que expirar (p. ej. el checkAuth
  // inicial de un visitante sin sesión): lo maneja el guard de rutas.
  if (!auth.isAuthenticated) return
  void auth.logout()
  void router.replace({ name: 'Login', query: { sessionExpired: '1' } })
})

onBeforeUnmount(() => {
  setUnauthorizedHandler(null)
})
</script>
